<template>
    <div v-if="isWhiteLabeling">
        <image-slider ref="imageSlider" v-if="showSlider" @getEula="getEula" :sliderData="sliderData"
                      :sliderLength="sliderLength"></image-slider>
        <div id="login-page-container-for-blur">
            <div class="login-page-container">
                <div class="login-page" v-blur="isRegister || isLoading" style="opacity: 0.2 !important;">
                    <login-modal ref="loginModal"></login-modal>
                    <world-map :feed="feed" :shouldDisplayGrid="true" @updateThreatWatch="updateThreatWatch"
                               :newFeedDisplayInterval="newFeedDisplayInterval"></world-map>
                    <threat-watch id="threat-watch" ref="threatWatch"></threat-watch>
                    <!-- <button id="login-button" @click="showLoginModal">Login</button> -->
                    <p id="login-title"
                       v-html="showOtherSupportMenu ? 'Valkyrie <br/> Threat Intelligence' : whitelabeling_configuration_data.name "></p>
                    <p id="login-sub-title">Malware Threats in Realtime</p>

                    <!-- Login Box -->
                    <img v-if="!showOtherSupportMenu" id="loginLogo" :src="customer_login_logo_url" width="4.2187%"
                         height="130.92">
                    <img v-if="showOtherSupportMenu" id="loginLogoWithWhiteLabeling" src="../assets/valkyrie-logo.svg"
                         width="4.2187%"
                         height="130.92">
                    <input id="login-input" class="login-input" type="text" placeholder="USER NAME"
                           v-show="viewInputFlag == 0"
                           v-model="username"
                           @keyup.enter="onLoginButtonClick" style="text-transform: lowercase;"/>
                    <input id="password-input" class="login-input" type="password" placeholder="password"
                           v-show="viewInputFlag == 1"
                           v-model="password"
                           @keyup.enter="onLoginButtonClick"/>
                    <input id="code-input" class="login-input" type="text" placeholder="CODE"
                           v-show="viewInputFlag == 2" v-model="code"
                           @keyup.enter="onLoginButtonClick"/>
                    <input id="auth-code-input" class="login-input" type="text" placeholder="authentication code"
                           v-show="viewInputFlag == 3" v-model="auth_code"
                           @keyup.enter="onLoginButtonClick"/>
                    <hr id="loginLine">
                    <button id="login-button" @click="onLoginButtonClick">{{loginButtonText}}</button>
                    <label id="lblNotifier" v-show="viewInputFlag == 2">We sent an sms containing verification code to
                        your
                        mobile phone. Please enter your notification code in {{counter}} seconds.</label>
                </div>
                <register-password-modal ref="registerPasswordModal"
                                         @signUpClicked="signUpClicked"></register-password-modal>
                <loading-modal class="loading-modal-container" v-if="isLoading"></loading-modal>
                <eula-modal ref="eulaModal" @agreeClicked="eulaAgreeClicked"></eula-modal>
                <terms-and-conditions-modal ref="termsAndConditionsModal"
                                            @eulaRead="setEula"></terms-and-conditions-modal>
                <forgotPassword-modal ref="forgotPasswordModal"></forgotPassword-modal>
                <set-new-password-modal :forgotPasswordHash="forgotPasswordHash"
                                        ref="setNewPasswordModal"></set-new-password-modal>
                <feedback-modal ref="feedbackModal"></feedback-modal>
                <faq-modal ref="faqModal"></faq-modal>
                <div class="footer">
                    <ul class="footer-links">
                        <li><a target="_blank" :href="whitelabeling_configuration_data.ctrl_link"
                               v-html="showOtherSupportMenu ? 'Comodo Threat Research Labs' : whitelabeling_configuration_data.ctrl_text "></a>
                        </li>
                        <li><a target="_blank" :href="whitelabeling_configuration_data.api_sdk_text"
                               v-html="showOtherSupportMenu ? 'API & SDK' : whitelabeling_configuration_data.api_sdk_text "></a>
                        </li>
                        <li><a @click="onForgotPasswordClicked">Forgot Password</a></li>
                        <li v-if="showOtherSupportMenu"><a @click="onFeedbackClicked">Feedback</a></li>
                        <li v-if="showOtherSupportMenu"><a @click="onFaqClicked">FAQ</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import WorldMap from '@/components/world-map/WorldMap.vue'
    import ThreatWatch from '@/components/threat-watch/ThreatWatch.vue'

    import LoginModal from '@/components/modals/LoginModal.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import Constants from '@/utils/constants'
    import Common from '@/utils/Common.vue'
    import RegisterPasswordModal from '@/components/modals/RegisterPasswordModal.vue'
    import EulaModal from '@/components/modals/EulaModal.vue'
    import TermsAndConditionsModal from '@/components/modals/TermsAndConditionsModal.vue'
    import ForgotPasswordModal from '@/components/modals/ForgotPasswordModal.vue'
    import SetNewPasswordModal from '@/components/modals/SetNewPasswordModal.vue'
    import FeedbackModal from '@/components/modals/FeedbackModal.vue'
    import FaqModal from '@/components/modals/FaqModal.vue'
    import ImageSlider from '@/components/modals/ImageSlider.vue'
    import {mapActions} from 'vuex';

    //Constants
    const MIN_PASSWORD_LENGTH = 8;
    const STATUS_POC = 7;

    //Notification Types
    const NOTIFICATION_ERROR = 1;
    const NOTIFICATION_SUCCESS = 2;

    export default {
        name: "login-page",
        components: {
            WorldMap: WorldMap,
            ThreatWatch: ThreatWatch,
            LoginModal: LoginModal,
            RegisterPasswordModal: RegisterPasswordModal,
            LoadingModal: LoadingModal,
            EulaModal: EulaModal,
            TermsAndConditionsModal: TermsAndConditionsModal,
            ForgotPasswordModal: ForgotPasswordModal,
            SetNewPasswordModal: SetNewPasswordModal,
            FeedbackModal: FeedbackModal,
            FaqModal: FaqModal,
            ImageSlider: ImageSlider
        },
        mixins: [Common],
        data() {
            return {
                feed: [],
                viewInputFlag: 0,
                showSlider: false,
                eulaData: null,
                sliderData: [],
                sliderLength: null,

                username: null,
                password: null,
                code: null,
                phone: null,
                counter: 0,
                interval: null,
                id: 0,
                message_id: '',

                isRegister: false,
                isLoading: false,
                registerHash: null,
                forgotPasswordHash: null,
                showEula: false,

                user: {
                    email: null,
                    enterprise_id: null,
                    browser: null,
                    ip: null
                },

                eula_user_id: null,
                newFeedDisplayInterval: 0,

                auth_code: null,
                whitelabeling_configuration_data: {},
                whitelabeling_login_configuration_data: {},
                showOtherSupportMenu: true,
                isWhiteLabeling: false,
                customer_login_logo_url: null

            }
        },
        methods: {
            setNewPassword() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/check_hash_link';
                let body = {
                    forgotPasswordHash: this.forgotPasswordHash
                };
                this.$http.post(path, body)
                    .then(response => {
                        if (!response.body.data.is_expired) {
                            this.$refs.setNewPasswordModal.showModal();
                        } else {
                            this.showErrorMessage("Link has expired.")
                        }
                    }, response => {
                        this.showErrorMessage("Link couldn't checked.")
                    });
            },
            checkIfDelegated() {
                this.getSliderData();
            },
            fetchNewFeedData() {
                var path = Constants.BACKEND_URL + '/threat/flow/all-malware-files';
                var params = {};
                if (this.latestTimestamp)
                    params.latestTimestamp = this.latestTimestamp;

                this.$http.get(path, {params: params})
                    .then(response => {
                        this.feed = this.feed.concat(response.body);
                        if (this.feed && this.feed.length > 0)
                            this.latestTimestamp = this.feed[this.feed.length - 1].timestamp;

                        this.newFeedDisplayInterval = Math.ceil(1000 / (this.feed.length / 300));
                    }, response => {
                    });
            },
            periodicallyFetchNewFeedData() {
                var self = this;
                this.fetchNewFeedData();
                setInterval(() => {
                    self.fetchNewFeedData();
                }, 1000 * 60 * 5);
            },
            showLoginModal() {
                this.$refs.loginModal.showModal();
            },
            onLoginButtonClick() {
                if (this.viewInputFlag == 0) {
                    if (this.username) {
                        this.viewInputFlag = 1;
                        setTimeout(function () {
                            $("#password-input").focus();
                        }, 250);
                    }
                } else if (this.viewInputFlag == 1) {
                    var data = {
                        email: this.username,
                        password: this.password
                    };

                    this.isLoading = true;
                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/checktwofactorauthusing', data)
                        .then(response => { // Success
                            if (response.body.data.two_factor_auth && response.body.data.phone_verified) {

                                if (response.body.data.sms_ok) {
                                    var self = this;
                                    self.counter = 180;
                                    this.viewInputFlag = 2;
                                    setTimeout(function () {
                                        $("#code-input").focus();
                                    }, 250);
                                    this.id = response.body.data.id;
                                    this.message_id = response.body.data.message_id;
                                    this.phone = response.body.data.phone;

                                    this.interval = setInterval(function () {

                                        if (self.counter == 1) {
                                            clearInterval(self.interval);
                                            this.resetLoginFields();
                                            self.code = null;
                                            self.phone = null;
                                        }

                                        self.counter--;
                                    }, 1000);
                                    this.isLoading = false;
                                } else {
                                    this.$toasted.show("Error occured during sms sending process. Please try again.", {
                                        position: "bottom-center",
                                        duration: 5000,
                                        type: 'error'
                                    });
                                    this.resetLoginFields();
                                    this.isLoading = false;
                                }
                            } else if (response.body.data.two_factor_auth && response.body.data.google_verified) {
                                this.viewInputFlag = 3;
                                setTimeout(function () {
                                    $("#auth-code-input").focus();
                                }, 250);
                                this.id = response.body.data.id;
                                this.isLoading = false;
                            } else {
                                this.login();
                            }
                        }, response => {
                            this.resetLoginFields();
                            this.isLoading = false;
                            if (response.status === Constants.ServerResponse.UNAUTHORIZED) {

                                this.$toasted.show("Login failed. Please try again.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else {
                                this.$toasted.show("Bad Request, Login failed. Please try again.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                        });
                } else if (this.viewInputFlag == 2) {
                    this.isLoading = true;

                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/loginsmsverification', {
                        id: this.id,
                        message_id: this.message_id,
                        code: this.code,
                        phone: this.phone
                    })
                        .then(response => { // Success
                            this.login();

                        }, response => { // verify error( bad request)
                            if (response.status === Constants.ServerResponse.BAD_REQUEST) {
                                this.$toasted.show("Verification code is invalid. Please check again.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.status === Constants.ServerResponse.SERVER_ERROR) { // server error
                                this.$toasted.show("Verification Failed", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                            this.isLoading = false;

                        });
                } else if (this.viewInputFlag == 3) {
                    this.isLoading = true;

                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/verify/google/auth', {
                        id: this.id,
                        auth_code: this.auth_code
                    })
                        .then(response => { // Success
                            this.login();

                        }, response => { // verify error( bad request)
                            if (response.status === Constants.ServerResponse.BAD_REQUEST) {
                                this.$toasted.show("Authentication code is invalid. Please check again.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.status === Constants.ServerResponse.SERVER_ERROR) { // server error
                                this.$toasted.show("Verification Failed", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                            this.isLoading = false;

                        });
                } else {
                    this.login();
                }
            },
            login() {
                this.removeAllFromStore();
                var data = {
                    email: this.username,
                    password: this.password,
                    browser: this.getBrowserName(),
                    ip: location.protocol + '//' + location.hostname + ':' + location.port
                };

                this.isLoading = true;
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/login', data)
                    .then(response => {
                        this.isLoading = false;
                        if (!response.data || !response.data.data) {
                            if (response.data.return_code === 'License Expired') {
                                this.$toasted.show("License Expired", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                                this.resetLoginFields();
                            } else {
                                this.$toasted.show("Login failed", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                                this.resetLoginFields();
                            }
                            return;
                        }
                        if (this.hasValidResponse(response)) {
                            this.setUserInformation(response);
                            if (response.data.data['user'].hasOwnProperty('manager')
                                && response.data.data['user']['manager'].hasOwnProperty('role')) {
                                this.getCustomerLoginWhiteLabeling(true);
                                // this.$router.push("/");
                            } else {
                                this.eulaData = response.data.data.user;
                                // this.checkEula(response.data.data.user);
                                if (parseInt(this.eulaData.status) >= STATUS_POC && this.eulaData.demo_eula_accepted === 'False') {
                                    this.getCustomerLoginWhiteLabeling(false);
                                    $('#login-page-container-for-blur').css('opacity', '.1');
                                    $('#login-page-container-for-blur').css('pointer-events', 'none');
                                    $('#login-page-container-for-blur').css('overflow-y', 'hidden');
                                    this.showSlider = true;
                                    this.showImageSlider();
                                } else {
                                    this.getCustomerLoginWhiteLabeling(true);
                                    // this.$router.push("/");
                                }

                            }
                        } else {
                            this.$toasted.show("Login failed", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                            this.resetLoginFields();
                        }
                    }, response => {
                        this.resetLoginFields();
                        this.isLoading = false;
                        this.$toasted.show("Login failed", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    });
            },
            resetLoginFields() {
                this.viewInputFlag = 0;
                this.username = null;
                this.password = null;
                setTimeout(function () {
                    $("#login-input").focus();
                }, 250);
            },
            showImageSlider() {
                this.$refs.imageSlider.showModal();
            },
            checkEula(userResponse) {

                // if (parseInt(userResponse.status) >= STATUS_POC && userResponse.demo_eula_accepted === 'False') {
                //     this.eula_user_id = userResponse.user_id;
                //     this.$refs.eulaModal.showModal(userResponse.user_id);
                // } else {
                //     this.$router.push("/");
                // }
                this.eula_user_id = userResponse.user_id;
                this.$refs.eulaModal.showModal(userResponse.user_id);
            },
            setEula(data) {
                var body = {
                    accept: data.accept,
                    // username: this.user.email,
                    // enterprise_id: this.user.enterprise_id,
                    ip: location.protocol + '//' + location.hostname + ':' + location.port,
                    user_id: parseInt(this.eula_user_id)
                }

                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/set_eula', body)
                    .then(response => {
                        this.$refs.termsAndConditionsModal.hideModal();
                        this.$router.push("vi");
                    }, response => {
                        this.$toasted.show("Set eula failed", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    });
            },
            delegate() {

            },
            getRegisterInfo() {
                var data = {
                    email_key: this.registerHash,
                    browser: this.getBrowserName(),
                    ip: location.protocol + '//' + location.hostname + ':' + location.port
                };

                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/update_password/get', data)
                    .then(response => {
                        if (this.hasValidResponse(response)) {
                            this.user.email = response.data.data.email;
                            this.user.enterprise_id = response.data.data.enterprise_id;
                            if (this.user.email != undefined && this.user.email != null && this.user.email != ''
                                && this.user.enterprise_id != undefined && this.user.enterprise_id != null && this.user.enterprise_id != '') {
                                let comp = this;
                                setTimeout(function () {
                                    comp.$refs.registerPasswordModal.showModal()
                                }, 2000);
                            } else {
                                this.isRegister = false;
                            }
                        } else {
                            this.$toasted.show("Request failed.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    }, response => {
                        if (response.status == 401) {
                            this.$toasted.show("Verification link has expired", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else {
                            this.$toasted.show("Request failed", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                        this.isRegister = false;
                        this.$router.push("/login");
                    });
            },
            signUpClicked(data) {
                if (data.password != null && data.confirmPassword != null
                    && data.password.length != 0 || data.password.length != 0) {
                    if (data.password.length >= MIN_PASSWORD_LENGTH) {
                        if (data.password == data.confirmPassword) {
                            this.user.browser = this.getBrowserName();
                            this.user.ip = location.protocol + '//' + location.hostname + ':' + location.port;
                            this.user.password = data.password;
                            var body = {
                                user: this.user,
                                email_key: this.registerHash
                            }

                            this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/update_password', body)
                                .then(response => {
                                    if (this.hasValidResponse(response)) {
                                        if (response.data.return_code == 1) {
                                            this.$toasted.show("Your password has been set please login to system", {
                                                position: "bottom-center",
                                                duration: 5000,
                                                type: 'success'
                                            });
                                            this.$refs.registerPasswordModal.clearAndHideModal();
                                            this.isRegister = false;
                                        } else {
                                            this.$toasted.show("Password Set failed, please try again", {
                                                position: "bottom-center",
                                                duration: 5000,
                                                type: 'error'
                                            });
                                        }
                                    } else {
                                        this.$toasted.show("Password Set failed, please try again", {
                                            position: "bottom-center",
                                            duration: 5000,
                                            type: 'error'
                                        });
                                    }

                                    this.$router.push("/login");
                                }, response => {
                                    if (response.status == 401) {
                                        this.$toasted.show("Code expired or used before", {
                                            position: "bottom-center",
                                            duration: 5000,
                                            type: 'error'
                                        });
                                    } else {
                                        this.$toasted.show("Password Set failed, please try again", {
                                            position: "bottom-center",
                                            duration: 5000,
                                            type: 'error'
                                        });
                                    }
                                    this.$refs.registerPasswordModal.clearAndHideModal();
                                    this.isRegister = false;
                                    this.$router.push("/login");
                                });
                        } else {
                            this.$toasted.show("No match!", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    } else {
                        this.$toasted.show("Password field is too short", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                } else {
                    this.$toasted.show("Password field is too short", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            eulaAgreeClicked() {
                this.$refs.eulaModal.hideModal();
                this.$refs.termsAndConditionsModal.showModal();
            },
            updateThreatWatch(data) {
                this.$refs.threatWatch.updateValues(data.virusPercent, data.trojanPercent, data.avgThreatLevel);
            },

            onForgotPasswordClicked() {
                this.$refs.forgotPasswordModal.showModal();
            },
            onFeedbackClicked() {
                this.$refs.feedbackModal.showModal();
            },
            onFaqClicked() {
                this.$refs.faqModal.showModal();
            },
            getEula() {
                this.checkEula(this.eulaData);
            },
            getSliderData() {
                let body = {
                    page: 1
                };

                var path = Constants.INTELLIGENCE_BACKEND_URL + '/settings_slides';

                this.$http.post(path, body).then(response => {
                    this.sliderData = response.body.data;
                    this.sliderLength = this.sliderData.length;
                }, response => {
                });
            },
            getLoginInformation() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/whitelabeling_by_customer_login_url';
                let url = window.location.href;
                let body = {
                    customer_login_url: url
                };
                this.$http.post(path, body).then(response => {
                    this.whitelabeling_configuration_data = response.body.data.whitelabeling_configuration;
                    this.customer_login_logo_url = this.whitelabeling_configuration_data.customer_login_logo_path;
                    this.showOtherSupportMenu = this.whitelabeling_configuration_data.show_other_footer_elements;
                    this.isWhiteLabeling = true;
                }, response => {
                    this.$toasted.show("Error Loading Page.", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                });
            },
            getCustomerLoginWhiteLabeling(willOpenMainPage) {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/whitelabeling_by_enterprise_id';
                let body = {
                    enteprise_id: ''
                };
                this.$http.post(path, body).then(response => {
                    this.whitelabeling_login_configuration_data = response.body.data.whitelabeling_configuration;
                    this.setWhiteLabelingData(this.whitelabeling_login_configuration_data);
                    if (willOpenMainPage) {
                        this.$router.push("/");
                    }
                }, response => {

                });
            },
            ...mapActions([
                "setWhiteLabelingData"
            ])
        },
        computed: {
            loginButtonText() {
                switch (this.viewInputFlag) {
                    case 0:
                        return "NEXT";
                    case 1:
                        return "LOGIN";
                    case 2:
                        return "VERIFY";
                    case 3:
                        return "VERIFY";
                }
                // return this.nextPressed ? "LOGIN" : "NEXT";
            }
        },
        mounted() {

            this.getSliderData();
            // this.showImageSlider();
            // this.checkIfDelegated();
            this.periodicallyFetchNewFeedData();

            if (this.$route.path.indexOf('/registerPassword') != -1) {
                this.isRegister = true;
                this.registerHash = this.$route.params[0];
                this.getRegisterInfo();
            }

            if (this.$route.path.indexOf('/updatePassword') != -1) {
                this.forgotPasswordHash = this.$route.params[0];
                // this.setNewPassword();
                var component = this;
                setTimeout(function () {
                    component.setNewPassword();
                }, 2000)

            }
        },
        beforeMount() {
            this.getLoginInformation();
        }
    }

</script>

<style scoped>

    .login-page-container {
        width: 100vw;
        height: 100vh;
    }

    .login-page {
        width: 100vw;
        height: 100vh;
        min-width: 1280px !important;
        min-height: 720px !important;
        overflow: auto;
        position: relative;
    }

    #login-button {
        font-family: 'Digital-Serial-Bold';
        width: 9.4791%;
        height: 7.8%;
        background-color: rgba(0, 255, 169, 1);
        border: 1px solid rgba(0, 255, 169, 1);
        border-radius: 2px;
        position: absolute;
        top: 28.5%;
        right: 5.2%;
        font-size: 1.5em;
        color: rgba(52, 63, 73, 1);
        cursor: pointer;

        animation-duration: 2s;
        animation-name: heartbeat;
        animation-iteration-count: infinite;

        -webkit-backface-visibility: hidden;
    }

    #login-title {
        font-family: 'Digital-Serial-Regular';
        position: absolute;
        top: 6%;
        left: 4%;
        font-size: 3.2em;
        color: rgba(0, 255, 169, 1);
        text-shadow: 0em 0em 0.375em rgba(0, 255, 169, 1);
    }

    #login-sub-title {
        font-family: 'Digital-Serial-Regular';
        position: absolute;
        bottom: 6%;
        right: 4%;
        font-size: 1em;
        color: rgba(0, 255, 169, 1);
        text-shadow: 0em 0em 0.375em rgba(0, 255, 169, 1);
    }

    #threat-watch {
        position: absolute;
        top: calc(58.7% + (35.2% - 16vw) / 2);
        left: 9.0729%;
        width: 15.5vw;
        height: 15.5vw;
        min-width: 200px;
        min-height: 200px;
        padding-left: 0%;
    }

    .login-input {
        background-color: transparent;
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Bold';
        font-size: 1.125em;
        text-align: center;
        border: none;
        width: 12.6458%;
        position: absolute;
        right: 3.7%;
        top: 20.5%;
        line-height: 18px;
    }

    .login-input::placeholder {
        color: rgba(1, 100, 79, 1);
        font-family: 'Digital-Serial-Bold';
    }

    #loginLine {
        display: block;
        height: 1px;
        border: 0;
        margin: 0;
        border-top: 1px solid rgba(0, 255, 169, 1);
        padding: 0;
        width: 13.6458%;
        position: absolute;
        right: 3.5%;
        top: 23.4%;
    }

    #lblNotifier {
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Regular';
        position: absolute;
        top: 42%;
        left: 84%;
        width: 12%;
        height: 8%;
    }

    #loginLogo {
        position: absolute;
        right: 8.3%;
        top: 3%;
    }

    #loginLogoWithWhiteLabeling {
        position: absolute;
        right: 8.3%;
        top: 3%;
    }

    @keyframes heartbeat {
        0% {
            transform: scale(.9);
        }
        20% {
            transform: scale(1);
        }
        40% {
            transform: scale(.9);
        }
        60% {
            transform: scale(1);
        }
        80% {
            transform: scale(.9);
        }
        100% {
            transform: scale(.9);
        }
    }

    .footer {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
    }

    .footer-links {
        padding-left: 0px;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .footer ul {
        margin: 0;
    }

    .footer li {
        display: inline-block;
        color: rgba(0, 255, 169, 1);
    }

    .footer li a {
        padding: 0 1rem;
        color: rgba(0, 255, 169, 1);
        cursor: pointer;
    }

    .footer li:after {
        content: "|";
    }

    .footer li:last-child:after {
        content: "";
    }

</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue